import { render, staticRenderFns } from "./SalesDocumentsPage.vue?vue&type=template&id=1242ab34&scoped=true"
import script from "./SalesDocumentsPage.vue?vue&type=script&lang=js"
export * from "./SalesDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./SalesDocumentsPage.vue?vue&type=style&index=0&id=1242ab34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242ab34",
  null
  
)

export default component.exports